export enum TransactionFilterKeyTypeEnum {
    SOURCE_SITE = 'sourceSiteIds',
    SOURCE_LOCATION = 'sourceLocationIds',
    DESTINATION_SITE = 'destinationSiteIds',
    DESTINATION_LOCATION = 'destinationLocationIds',
    ACTOR = 'actorIds',
  }